import { fromJS, Map, List } from 'immutable';
import { SupplierRecord } from './../Record/Supplier';
const NAME_SPACE = 'SUPPLIER/';
const initialState = new Map({
  'loading': true,
  'data': new List([new SupplierRecord()]),
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialState.update('loading', () => false);;
    case NAME_SPACE + 'RECEIVE_SUPPLIER':
      const _state = state.update('loading', () => false);
      return _state.update('data', data => List([fromJS(action.payload.supplier)]));
    case NAME_SPACE + 'RECEIVE_SUPPLIER_COLLECTION':
      return fromJS(action.payload.suppliers);
    case NAME_SPACE + 'ADD_SUPPLIER':
      return state.update('data', data => data.push(action.payload.supplier));
    case NAME_SPACE + 'EDIT_SUPPLIER':
      return state.update('data', data => data.push(action.payload.supplier));
    case NAME_SPACE + 'ADD_IMAGE':
      return state.update('data', data => {
        return data.update(0, data => {
          return data.update('attachments', attachments => attachments.push(action.payload.img));
        });
      });
    case NAME_SPACE + 'DEL_IMAGE':
      return state.update('data', data => {
        return data.update(0, data => {
          return data.update('attachments', attachments => attachments.delete(attachments.findIndex(x => x.uid === action.payload.uid)));
        });
      });
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

const Supplier = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'RECEIVE_SUPPLIER':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_SUPPLIER_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'ADD_SUPPLIER':
      return item(state, action);
    case NAME_SPACE + 'Edit_SUPPLIER':
      return item(state, action);
    case NAME_SPACE + 'ADD_IMAGE':
      return item(state, action);
    case 'DEL_IMAGE':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};

export default Supplier;